import React, { useState, useEffect, useCallback } from 'react';

const STATUS_STYLES = {
  'success': { color: '#22c55e', bg: 'rgba(34,197,94,0.1)' },
  'failure': { color: '#ef4444', bg: 'rgba(239,68,68,0.1)' },
  'pending': { color: '#f59e0b', bg: 'rgba(245,158,11,0.1)' },
  'info':    { color: '#60a5fa', bg: 'rgba(96,165,250,0.1)' },
};

const s = {
  heading: { fontSize: '1.3rem', fontWeight: '700', color: '#e0e0e0', marginBottom: '0.5rem' },
  meta: { color: '#555', fontSize: '0.82rem', marginBottom: '1.25rem' },
  code: {
    background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: '8px',
    padding: '0.9rem 1.1rem', marginBottom: '1.5rem', fontFamily: 'monospace',
    fontSize: '0.82rem', color: '#818cf8', overflowX: 'auto',
  },
  refreshBtn: {
    padding: '0.45rem 1rem', background: 'transparent', border: '1px solid #2a2a4a',
    borderRadius: '7px', color: '#999', cursor: 'pointer', fontSize: '0.85rem',
    marginBottom: '1.25rem',
  },
  logList: { display: 'flex', flexDirection: 'column', gap: '0.5rem' },
  logCard: {
    background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: '10px',
    padding: '0.85rem 1rem',
  },
  logRow: { display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '0.3rem' },
  agentName: { fontWeight: '700', color: '#e0e0e0', fontSize: '0.9rem' },
  statusBadge: (status) => ({
    padding: '0.18rem 0.55rem', borderRadius: '4px', fontSize: '0.7rem', fontWeight: '700',
    color: (STATUS_STYLES[status] || STATUS_STYLES.info).color,
    background: (STATUS_STYLES[status] || STATUS_STYLES.info).bg,
    textTransform: 'uppercase',
  }),
  timestamp: { color: '#555', fontSize: '0.78rem', marginLeft: 'auto' },
  action: { color: '#aaa', fontSize: '0.88rem', lineHeight: '1.4' },
  empty: { color: '#555', textAlign: 'center', padding: '2rem', fontSize: '0.95rem' },
};

function formatDate(ts) {
  const d = new Date(ts);
  return d.toLocaleString();
}

export default function AgentLog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchLogs = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/agent-log', { credentials: 'same-origin' });
      if (res.ok) setLogs(await res.json());
    } catch {}
    setLoading(false);
  }, []);

  useEffect(() => { fetchLogs(); }, [fetchLogs]);

  return (
    <div>
      <div style={s.heading}>Agent Log</div>
      <div style={s.meta}>Entries written by AI agents via the API. Read-only view.</div>

      <div style={s.code}>
        <div style={{ color: '#555', marginBottom: '0.4rem' }}># Agent write endpoint</div>
        <div>POST /api/agent-log</div>
        <div style={{ color: '#555', marginTop: '0.4rem' }}>Authorization: Bearer {'<AGENT_API_KEY>'}</div>
        <div style={{ color: '#555' }}>{'{'} "agent_name": "...", "action": "...", "status": "success|failure|pending|info" {'}'}</div>
      </div>

      <button style={s.refreshBtn} onClick={fetchLogs} disabled={loading}>
        {loading ? 'Refreshing...' : '↻ Refresh'}
      </button>

      <div style={s.logList}>
        {logs.length === 0 && !loading && (
          <div style={s.empty}>No log entries yet.</div>
        )}
        {logs.map(log => (
          <div key={log.id} style={s.logCard}>
            <div style={s.logRow}>
              <span style={s.agentName}>{log.agent_name}</span>
              <span style={s.statusBadge(log.status)}>{log.status}</span>
              <span style={s.timestamp}>{formatDate(log.created_at)}</span>
            </div>
            <div style={s.action}>{log.action}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
